import ApiClient from './ApiClient';

/* global axios */

class ZapiWoot extends ApiClient {
  constructor() {
    super('zapiwoot/settings', { accountScoped: true });
  }

  updateChannelSignature(payload) {
    return axios.post(`${this.url}/channel_signature`, payload);
  }
}

export default new ZapiWoot();
